import React from 'react'
import Svg, { G, Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconMarker = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconMarker.dimensions.width} ${IconMarker.dimensions.height}`}
      {...otherProps}
    >
      <G fill={color || Color.premiumBlack} fillRule="nonzero">
        <Path d="M.046 4.424c.059-.26.113-.518.186-.772C.769 1.801 2.635.556 4.472.809c2.04.284 3.545 1.915 3.51 3.922-.009.61-.214 1.24-.444 1.817-.835 2.1-2.031 4.005-3.252 5.895-.142.22-.303.298-.47.04C2.485 10.406 1.157 8.33.326 5.986.203 5.65.139 5.288.05 4.937v-.508l-.005-.005Zm3.893 7.58.142-.04c1.186-1.89 2.388-3.775 3.174-5.885.176-.469.313-.991.293-1.48-.102-2.202-2.036-3.702-4.2-3.306C1.365 1.654.081 3.72.672 5.645c.2.644.454 1.28.766 1.87.806 1.51 1.666 2.99 2.5 4.484v.005ZM1.717 13.586c-.113-.361-.069-.435.298-.435h4.044c.366 0 .415.074.297.435h-4.64Z" />
        <Path d="M4.042 2.377A2.385 2.385 0 0 1 6.43 4.775a2.409 2.409 0 0 1-2.398 2.398 2.402 2.402 0 0 1-2.384-2.412 2.385 2.385 0 0 1 2.398-2.389l-.005.005ZM5.995 4.79a1.95 1.95 0 0 0-1.939-1.978 1.945 1.945 0 0 0-1.978 1.934 1.97 1.97 0 0 0 1.934 1.988C5.077 6.748 5.98 5.86 5.99 4.79h.005Z" />
      </G>
    </Svg>
  )
}

IconMarker.dimensions = {
  width: 8,
  height: 14,
}

export default IconMarker
